import React from 'react';
import PropTypes from 'prop-types';
import { eventEmitter } from '../services';

const DEFAULT_SIZE = 576;

class Column extends React.Component {

    render() {
        const {
            children,
            width,
            left,
        } = this.props;

        const columnStyle = { ...styles.column, ...{ width }, ...{ left } };

        return (
            <div style={{ ...columnStyle }} >
                {children}
            </div>
        );
    }
}

Column.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    width: PropTypes.number,
    left: PropTypes.number,
};

class GridColumns extends React.Component {

    constructor() {
        super();

        this.state = {
            openMenu: true,
            dockedMenu: true,
        };

        eventEmitter.subscribe('change-drawer', (drawerState) => {
            if (this.refs.gridColumnsRef) {
                this.setState(drawerState);
            }
        });
    }

    componentWillUnmount() {
        eventEmitter.unsubscribe('change-drawer');
    }

    render() {
        const {
            children,
        } = this.props;
        const {
            openMenu,
            dockedMenu,
        } = this.state;

        const validChildren = [];
        let width = 0;
        let left = (openMenu && dockedMenu) ? 350 : 0;
        React.Children.forEach(children, (child, index) => {
            if (!React.isValidElement(child) || child.type !== Column) {
                return;
            }
            const childObject = { left, child };
            const childWidth = child.props.width ? child.props.width : DEFAULT_SIZE;
            width += childWidth;
            left += childWidth;
            childObject.width = childWidth;
            validChildren.push(childObject);
        });

        const childrenWithProps = React.Children.map(validChildren.map(x => x.child), (child, index) =>
            React.cloneElement(child, { width: validChildren[index].width, left: validChildren[index].left }));

        return (
            <div style={{ ...styles.columns, ...{ width } }} ref="gridColumnsRef">
                {childrenWithProps}
            </div>
        );
    }
}

GridColumns.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]).isRequired,
};

const styles = {
    columns: {
        overflowX: 'auto',
    },
    column: {
        height: '100vh',
        position: 'absolute',
        display: 'inline-block',
        borderRight: '.5px solid rgba(0, 0, 0, 0.23)',
        verticalAlign: 'top',
        overflowY: 'auto',
    },
};

export {
    GridColumns,
    Column,
};
